import React from 'react';
import { useHistory, useParams  } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useUpdateMutation, useGetUserQuery } from '../../../services/userApi';
import Container from '../add-user/container';

const AddUser = ({}:any) => {
    const { userId } = useParams<any>();
    const { data: user, isLoading: userIsLoading, error } = useGetUserQuery({ userId });    
    const [ update, { isLoading, error: addError }] = useUpdateMutation();

    let history = useHistory();

    const onUpdateUser = (user: any) => {        
        update({...user, userId })
        .unwrap()
        .then((response: any) => {
            toast.success("Successfully updated user");
            history.push(`/admin/user/list`);
         })
         .catch((error) => { toast.error("Error updating user") });
      };

    return (
        <Container title="Edit User" 
            user={user} 
            userIsLoading={userIsLoading} 
            onSave={onUpdateUser}
            isLoading={isLoading}
            error={{...error, ...addError}}
            emailAddressReadOnly={true} />
    )    
};

export default AddUser;